import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Title text="Letzte Publikationen" mdxType="Title" />
    <ul>
      <li parentName="ul">{`Europäische Ethnologie und Kulturwissenschaften. Marburg: Jonas Verl. 2013 `}</li>
      <li parentName="ul">{`Fremde gehören Immer dazu. Weimar. VDG Weimar/Bauhaus-Universitätsverlag 2016 `}</li>
      <li parentName="ul">{`Konsumwelten und die Krise der Wachstumsgesellschaft. Marburg/Weimar 2016 `}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      